// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState__wrap___O37u","compact":"EmptyState__compact__M8iAC","title":"EmptyState__title__NzPMJ","description":"EmptyState__description__uYXGH"};